import lightGrayButtonRule from '../../../light-gray/background/default/secondary';

const secondary = (params) => lightGrayButtonRule(params);

export default secondary;
